import TextArea from "./TextArea";
export { default as ResizableTextArea } from "./ResizableTextArea";
export default TextArea;